import { connect } from "react-redux"
import SearchPage from "."
import { push } from "react-router-redux"
import PropTypes from "prop-types"

const mapDispatchToProps = (dispatch, ownProps) => ({
  redirect: () => {
    dispatch(push("/facility/" + ownProps.facilityId + "/assets"))
  },
})

const SearchPageWithStore = connect(null, mapDispatchToProps)(SearchPage)

SearchPageWithStore.propTypes = {
  facilityId: PropTypes.string.isRequired,
}

export default SearchPageWithStore
